export const LAYOUT_CONTAINER_ID = 'layout-container';
export const LAYOUT_HEADER_ID = 'layout-header';
export const FOOTPRINT_FOOTER_ID = 'footprint-footer';
